import { useEffect, useRef, useState } from "react";

// True while the window is actively scrolling (either direction), flipping
// back to false once scroll events have been idle for `idleDelay` ms. There
// is no "scroll ended" DOM event, so idleness is the only way to detect a
// stopped scroll; the delay has to stay comfortably above the ~16ms gap
// between events during a fling, or the footer would flicker mid-scroll. It
// doubles as a settle time — long enough that a pause between two flicks
// doesn't pop the footer back up only to hide it again.
const useIsScrolling = (idleDelay = 800) => {
  const [isScrolling, setIsScrolling] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      // React bails out of re-rendering when the value is unchanged, so this
      // is a no-op for every event after the first of a given scroll burst.
      setIsScrolling(true);
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => setIsScrolling(false), idleDelay);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(timeoutRef.current);
    };
  }, [idleDelay]);

  return isScrolling;
};

export default useIsScrolling;
